<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-home"></i> 牌照关系维护
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
		<div class="handle-box">
			<el-button
			    type="primary"
			    icon="el-icon-circle-plus-outline"
			    class="handle-add"
			    @click="addlicense('addlicenseform')"
			>添加</el-button>
		</div>
        <div class="container">
            <el-table
                :data="prefixlicenseData"
                border
                class="table"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="areaName" label="区域名称"></el-table-column>
                <el-table-column prop="prefixLicense" label="号牌前缀" align="center"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="editlicence(scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="deletePrefixLicense(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		<!-- 添加机构分支 -->
		<el-dialog class="branch-dialog" title="添加牌照关系" :visible.sync="addlicenseVisible" width="600px">
		    <el-form ref="addlicenseform" :model="addlicenseform" :rules="addlicenserules">
		        <el-form-item label="区域" prop="provincecityid">
		        	<el-cascader ref="cascaderAddr" :options="cityList" :props="optionProps" v-model="addlicenseform.provincecityid" style="width: 100%;"></el-cascader>
		        </el-form-item>
				<el-form-item label="对应牌照前缀"  prop='prefixLicense'>
				    <el-input v-model="addlicenseform.prefixLicense"></el-input>
				</el-form-item>
		    </el-form>
			
		    <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="savelicenceadd('addlicenseform')">确 定</el-button>
		        <el-button @click="addlicenseVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
		
		
		
        <!-- 编辑弹出框 -->
        <el-dialog class="branch-dialog" title="编辑牌照关系" :visible.sync="editlicenseVisible" width="600px">
            <el-form ref="editlicenseform" :model="editlicenseform" :rules="addlicenserules">
                <el-form-item label="区域" prop="provincecityid">
                	<el-cascader ref="cascaderAddr" :options="cityList" :props="optionProps" v-model="editlicenseform.provincecityid" style="width: 100%;"></el-cascader>
                </el-form-item>
            	<el-form-item label="对应牌照前缀"  prop='prefixLicense'>
            	    <el-input v-model="editlicenseform.prefixLicense"></el-input>
            	</el-form-item>
            </el-form>
            
            <span slot="footer" class="dialog-footer">
            	<el-button type="primary" @click="savelicenceEdit('editlicenseform')">确 定</el-button>
                <el-button @click="editlicenseVisible = false">取 消</el-button>
            </span>
        </el-dialog>
		
		
    </div>
</template>




<script>
import {listProvinceCitys,listCitys,getCity,deletePrefixLicense,updateCity} from '@/api/index';// 导入我们的api接口

export default {
    name: 'licencerelation',
    data() {
        return {
			cityList:[],//省市数据
			optionProps: {
				// TODO
					value: 'id',
					label: 'name'
			},   //省市联动重命名指向
            query: {
                pageIndex: 1,
                pageSize: 10
            },   //分页
			pageTotal: 0,  //数据总条数
            prefixlicenseData: [],  //列表数据
			addlicenseform:{
				provincecityid:[],
				prefixLicense:''
			},
			addlicenserules: {
				provincecityid: [
					{ required: true, message: '请输入分支机构名称', trigger:  ['blur', 'change']  }
				],
				prefixLicense: [
					{ required: true, message: '请输入对应牌照前缀', trigger:  ['blur', 'change']  },
					{ min: 2, max: 2, message: '长度为2个字符', trigger: 'blur' }
				]
			},  //添加表单验证
			editlicenseform:{
				provincecityid:[],
				prefixLicense:''
			},   //编辑表单
			addlicenseVisible:false,  //添加分支机构
            editlicenseVisible: false, //编辑分支机构
        };
    },
    created() {
		var that = this;
		//省市
		listProvinceCitys({
		}).then(res => {
		    // 获取数据成功后的其他操作
			that.cityList = res.data;
		});
		// 列表数据
		this.getlistCitys();
    },
    methods: {
		// 获取列表数据
		getlistCitys(){
			listCitys({
				current: this.query.pageIndex,                    
				size: this.query.pageSize              
			}).then(res => {
				// 获取数据成功后的其他操作
				this.prefixlicenseData = res.data.records;  
			    this.pageTotal = res.data.total;
			});
		},
		//点击添加按钮事件
		addlicense(formName){
			// console.log(formName)
			var that = this;
			that.addlicenseVisible = true;
			//重置表单数据
			that.$nextTick(()=>{
				// debugger
			  that.$refs.[formName].resetFields();
			})
		},
		// 添加保存
		savelicenceadd(formName) {
			
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				console.log(this.addlicenseform.provincecityid) 
				console.log(this.addlicenseform.provincecityid[0],this.addlicenseform.provincecityid[1]) 
				this.addlicenseform.provinceId = this.addlicenseform.provincecityid[0];
				this.addlicenseform.cityId = this.addlicenseform.provincecityid[1];
				  updateCity(this.addlicenseform).then(res => {
					  this.getlistCitys();
					  if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.addlicenseVisible = false;
					  }else if(res.code == 1){
						  this.$message({
						    message: res.message,
						    type: 'warning'
						  });
					  }else{
						  this.$message({
						    message: '报错啦!',
						    type: 'warning'
						  })
					  }
					   
				  })
			  } else {
				return false;
			  }
			})
		  },
		
        // 删除操作
        deletePrefixLicense(row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
				deletePrefixLicense({
					 "cityId": row.cityId          
				}).then(res => {
					this.query.pageIndex = 1;
					this.getlistCitys();
					if(res.code == 0){
					  // 获取数据成功后的其他操作
						this.$message({
						  message: res.message,
						  type: 'success'
						});
					}else if(res.code == 1){
						  this.$message({
							message: res.message,
							type: 'warning'
						  });
					}else{
						  this.$message({
							message: '报错啦!',
							type: 'warning'
						  });
					}
					
				});
			}).catch(() => {});
        },
        // 编辑操作updateBranchOrganization
        editlicence(row) {
			getCity({},{
					 "cityId": row.cityId
			}).then(res => {
				this.editlicenseform.provincecityid = [res.data.provinceId,res.data.cityId];
				this.editlicenseform.prefixLicense = res.data.prefixLicense;
				this.editlicenseVisible = true;
			});
        },
        // 保存编辑
        savelicenceEdit(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				this.editlicenseform.provinceId = this.editlicenseform.provincecityid[0];
				this.editlicenseform.cityId = this.editlicenseform.provincecityid[1];
				  updateCity(this.editlicenseform).then(res => {
					  this.getlistCitys();
					  if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.editlicenseVisible = false;
					  }else if(res.code == 1){
						  this.$message({
						    message: res.message,
						    type: 'warning'
						  });
					  }else{
						  this.$message({
						    message: '报错啦!',
						    type: 'warning'
						  })
					  }
					   
				  })
			  } else {
				return false;
			  }
			})
			
			
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getlistCitys();
        }
    }
};
</script>

<style scoped>
.question-box{
	display: flex;
	display: -webkit-flex;
	flex-wrap: wrap;
}
.question-box p{
	width: 270px;
}

	
	
.handle-box {
	height: 32px;
	line-height: 32px;
    margin-bottom: 20px;
}
.handle-add{
	float: right;
}
.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/* 弹框样式 */
.branch-dialog-title{
	border-left: 4px solid #409EFF;
	font-size: 16px;
	text-indent: 10px;
	margin-bottom: 20px;
}

.see-list p{
	/* line-height: 32px; */
	margin-bottom: 20px;
	letter-spacing: 1px;
	font-size: 14px;
	text-indent: 15px;
}



</style>
<style>
.resizeNone .el-textarea__inner{
         resize: none;  
 }	
	
.branch-dialog	.el-dialog__header{
	background:#409EFF;
	padding: 10px 20px;
}
.branch-dialog	.el-dialog__header	.el-dialog__title{
	color: #fff;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn{
	background:#409EFF;
	top: 12px;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn .el-dialog__close{
	color: #fff;
	font-size: 20px;
}
.branch-dialog .el-dialog__body{
	height:50vh;
	overflow-y: scroll;
	padding: 20px 20px 30px;
}
.branch-dialog.question-dialog .el-form-item__label{
	/* text-align: left; */
	width: 60px;
}
.branch-dialog.question-dialog .el-form-item__content{
	margin-left: 60px;
}

.branch-area{
	position: relative;
	height:32px;
	line-height: 32px;
	margin-bottom: 4px;
}
.branch-area span{
	display: block;
	width:118px;
	text-align: right;
}
.branch-area span::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
.branch-area i{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem{
	position: relative;
}
.branch-areaitem .el-cascader{
	width: 90%;
}
.branch-areaitem b{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-password .el-form-item__label::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
</style>
